import { ChangeDetectorRef, Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { merge, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { GCADANavigationItem } from '@GCADA/types';
import { GCADANavigationService } from '@GCADA/components/navigation/navigation.service';

@Component({
    selector: 'GCADA-nav-vertical-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss']
})
export class GCADANavVerticalItemComponent implements OnInit, OnDestroy {
    @HostBinding('class')
    classes = 'nav-item';

    @Input()
    item: GCADANavigationItem;

    public groupsList: any;
    public sdGroupsList: any;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     */

    /**
     *
     * @param {ChangeDetectorRef} _changeDetectorRef
     * @param {GCADANavigationService} GCADANavigationService
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _GCADANavigationService: GCADANavigationService
    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    /**
     * On init
     */
    ngOnInit(): void {
        //groups
        if (localStorage.getItem('_grps') != null || localStorage.getItem('_grps') != "" || localStorage.getItem('_grps') != undefined) {
            this.groupsList = localStorage.getItem('_grps');
        }

        //sdGroups
        if (localStorage.getItem('_sdGrps') != null || localStorage.getItem('_sdGrps') != "" || localStorage.getItem('_sdGrps') != undefined) {
            this.sdGroupsList = localStorage.getItem('_sdGrps');
        }
        // Subscribe to navigation item
        merge(
            this._GCADANavigationService.onNavigationItemAdded,
            this._GCADANavigationService.onNavigationItemUpdated,
            this._GCADANavigationService.onNavigationItemRemoved
        ).pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }


    //Hide and show menu on group base 
    showMenuOnGroupBase(groups): boolean {
        let showMenuGroup: boolean = false;
        if (this.groupsList) {
            let groupList = this.groupsList.split(',');
            let menuGroupList = groups.split(',');
            groupList.forEach(element => {
                for (var i = 0; i < menuGroupList.length; i++) {
                    if (element == menuGroupList[i]) {
                        return showMenuGroup = true;
                    }
                }
            });
        }

        return showMenuGroup;
    }

    //Hide and show menu on sdgroup base 
    showMenuOnSdGroupBase(sdGroups): boolean {
        let showMenuSdGroup: boolean = false;
        if (this.sdGroupsList) {
            let sdGroupList = this.sdGroupsList.split(',');
            let menuSdGroupList = sdGroups.split(',');
            sdGroupList.forEach(element => {
                for (var i = 0; i < menuSdGroupList.length; i++) {
                    if (element == menuSdGroupList[i]) {
                        return showMenuSdGroup = true;
                    }
                }
            });
        }

        return showMenuSdGroup;
    }

}
